export const roleConsentMapper = ({ value }: { value?: boolean | null }) => {
  return value ? 'Udělen' : 'Neudělen';
};

roleConsentMapper.displayName = 'roleConsentMapper';
